export enum SpaceTypes {
  ORGANISATION = 'organisation',
  WORKSPACE = 'workspace'
}
